import React from "react";
import { ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/140329da-214d-4361-8f65-2aa02dd6ca18/images/bf8c45dccd454101d023867596eefbd688ee4a7efe874265a8169a7f2a510dc4.png";

export default function Hero() {
  return (
    <section
      id="top"
      className="relative min-h-screen overflow-hidden pg-grain"
      data-testid="hero-section"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Pegasus Infra — luxury construction"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/85 via-[#0A0A0A]/70 to-[#0A0A0A]" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-screen flex flex-col justify-end pb-24 md:pb-32 pt-32">
        <div className="max-w-3xl pg-fade-up">
          <div
            className="text-[11px] uppercase tracking-[0.4em] text-[#D4AF37] mb-6 flex items-center gap-4"
            data-testid="hero-overline"
          >
            <span className="w-10 h-px bg-[#D4AF37]" />
            Design-Led Construction · Est. Since 2001
          </div>

          <h1
            className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-white mb-8"
            data-testid="hero-heading"
          >
            Built with <span className="italic text-[#D4AF37]">clarity</span>.
            <br />
            Delivered with <span className="italic text-[#D4AF37]">care</span>.
          </h1>

          <p className="text-lg text-[#A3A3A3] max-w-xl leading-relaxed mb-10">
            End-to-end civil solutions across industrial, commercial, residential,
            institutional and hospitality sectors — an integrated design-build
            partnership engineered for certainty.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              className="group inline-flex items-center justify-center gap-3 bg-[#D4AF37] hover:bg-[#E5C665] text-black px-8 py-4 text-sm tracking-wide transition-colors"
              data-testid="hero-cta-primary"
            >
              Start a Project
              <ArrowRight
                size={16}
                className="transition-transform group-hover:translate-x-1"
              />
            </a>
            <a
              href="#services"
              className="inline-flex items-center justify-center border border-[#D4AF37]/60 text-[#D4AF37] hover:bg-[#D4AF37]/10 px-8 py-4 text-sm tracking-wide transition-colors"
              data-testid="hero-cta-secondary"
            >
              Explore Services
            </a>
          </div>
        </div>

        {/* Stats strip */}
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8 pt-10 border-t border-white/10">
          {[
            ["24+", "Years of Experience"],
            ["5", "Sectors Served"],
            ["120+", "Projects Delivered"],
            ["1", "Accountable Partner"],
          ].map(([n, l]) => (
            <div key={l} data-testid={`hero-stat-${l.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="font-serif text-4xl md:text-5xl text-white">
                {n}
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-[#A3A3A3] mt-2">
                {l}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
